/**
 * CLO-S2 — Alarm/Trigger Settings show effective Safety Reflex + blast.
 * Read-only SoT. Define stays on Automations. AI cannot own. Soft≠ invent.
 */
import { html, Card, KV, Alert, go } from "./ui.js";
import { path, useApi } from "./api.js";

function safeReflexPath(op) {
  try {
    return path(op);
  } catch {
    /* contract miss — Live path, not a Soft invent */
  }
  if (op === "get__ai_safety_reflex") return "/ai/safety/reflex";
  return "";
}

export function SafetyReflexEffectiveCard() {
  const list = useApi(safeReflexPath("get__ai_safety_reflex"));
  const items = (list.data && list.data.items) || [];
  const conditions = (list.data && list.data.conditions) || [];
  const ceiling = (list.data && list.data.blast_ceiling) || {};
  const storeDown = String(list.error || "").includes("503")
    || /safety_reflex_store_unavailable/.test(String(list.error || ""));
  const first = items[0] || null;
  const blast = (first && first.blast_boundary) || {};

  return html`<div className="safety-reflex-effective" data-cmc-reflex-sot="1" data-soft-invent="0">
    <${Card} title="Safety Reflex (effective)" meta="condition · blast · version"
      sub="Safety priority ≠ decision brain. AI cannot silently own or expand blast.">
      ${storeDown
        ? html`<${Alert} tone="bad" title="Reflex store unavailable"
            say="Cannot invent an empty reflex list. Safety Reflex is unavailable until storage returns."/>`
        : null}
      ${list.error && !storeDown
        ? html`<${Alert} tone="warn" title="Reflex read refused"
            say="This seat cannot load Safety Reflex. Effective version is not invented."/>`
        : null}
      <${KV} k="Conditions" v=${list.loading ? "…" : String(conditions.length)}/>
      <${KV} k="Reflexes" v=${list.loading ? "…" : String(items.length)}/>
      <${KV} k="Decision brain" v="false"/>
      <${KV} k="AI can own" v="false"/>
      <${KV} k="Blast ceiling" v=${`max_targets=${ceiling.max_targets != null ? ceiling.max_targets : 1} · external=${String(!!ceiling.allow_external_message)}`}/>
      ${first
        ? html`<${KV} k="Effective" v=${`${first.name || first.reflex_id} · v${first.version || 1} · owner ${first.owner_kind || "—"}`}/>
          <${KV} k="Blast bound" v=${`max_targets=${blast.max_targets != null ? blast.max_targets : "—"} · external=${String(!!blast.allow_external_message)}`}/>
          <${KV} k="Event type" v=${String(first.event_type || "—")}/>`
        : html`<p className="note">No human Reflex defined yet. Alarm still ingests. Define on Automations · Safety Reflex.</p>`}
      <button type="button" className="btn btn--ghost btn--sm" style=${{ marginTop: 8 }}
        onClick=${() => go("/automations/safety")}>Open Safety Reflex</button>
    <//>
  </div>`;
}

export default SafetyReflexEffectiveCard;
